import { observer } from 'mobx-react';
import React from 'react';

import iframe from '../../dashboard-routes/Iframe/iframeData';
import TableToolbar from '../../shared/tableToolbar';
import TypeOfClaimsStore from './TypeOfClaimsStore';
import * as api from '../../../stores/api';
import router from '../../../stores/router';

const statusLabels = [
  { text: `All`, value: `All` },
  { text: `Active`, value: `active` },
  { text: `Inactive`, value: `inactive` },
];

@observer
class TypeOfClaimsToolbar extends React.Component {
  renderFilterOptions = () => {
    return statusLabels.map(opt => ({
      text: opt.text,
      value: opt.value,
    }));
  };

  renderFilterText = value => {
    let labels = statusLabels.filter(opt => opt.value === value).map(opt => opt.text);
    return labels[0];
  };

  handleFilter = (_, { value }) => {
    TypeOfClaimsStore.refetch({ filter: value, curPage: 1 }, true);
  };

  handSubmit = e => {
    e.preventDefault();
    TypeOfClaimsStore.refetch({ curPage: 1 }, true);
  };

  openCaseCreate = () => () => {
    var id = 0;
    if (localStorage.getItem(`TypeOfClaims`)) {
      localStorage.removeItem(`TypeOfClaims`);
    }
    iframe.forceOpenTab('PostTypesOfClaims', `?id=${id}&view=PostTypesOfClaims`, {
      id,
      view: 'PostTypesOfClaims',
    });
  };

  handExport = e => {
    const { keyword, filter } = TypeOfClaimsStore;
    window.open(`/TypesOfClaims/ExportSearchResult?keyword=${keyword}&status=${filter}`, '_blank');
  };

  onOpenCaseCreateNew = () => {
    localStorage.setItem('TypeOfClaims', 'Add/Edit Type Of Claim');
    router.history.push({
      pathname: '/view/add-edit-types-of-claims-2',
      state: {
        type: 'typeOfClaim',
      },
      search: `?id=${0}`,
    });
  };

  render() {
    const { keyword, loading, filter } = TypeOfClaimsStore;
    return (
      <React.Fragment>
        <TableToolbar.Container>
          <TableToolbar.Left>
            <TableToolbar.Input onChange={TypeOfClaimsStore.handleSearchChange} value={keyword} disabled={loading} />
            <TableToolbar.Filter
              disabled={loading}
              value={this.renderFilterText(filter)}
              label={`Status`}
              options={this.renderFilterOptions()}
              onChange={this.handleFilter}
            />
            <TableToolbar.SubmitButton disabled={loading} onClick={this.handSubmit}>
              Search
            </TableToolbar.SubmitButton>
            <TableToolbar.HighLightButton
              disabled={loading}
              className="negative"
              onClick={TypeOfClaimsStore.resetStore}
              style={{ marginLeft: '5px' }}
            >
              Clear
            </TableToolbar.HighLightButton>
            <TableToolbar.HighLightButton
              disabled={loading}
              className="positive"
              onClick={this.handExport}
              style={{ marginLeft: '5px' }}
            >
              Export Search Result
            </TableToolbar.HighLightButton>
          </TableToolbar.Left>
          <TableToolbar.Right>
            {api.isAdmin() && !api.isOnlySearch() && (
              <TableToolbar.HighLightButton disabled={loading} className="positive" onClick={this.onOpenCaseCreateNew}>
                Add Type of claims
              </TableToolbar.HighLightButton>
            )}
          </TableToolbar.Right>
        </TableToolbar.Container>
      </React.Fragment>
    );
  }
}

export default TypeOfClaimsToolbar;
